import { isAfter, parseISO } from 'date-fns';
import type { Customer } from '../api/common/model/customer';

export function customerHasFairDowngrade(customer: Customer | null | undefined): boolean {
  if (!customer) {
    return false;
  }

  const { status, currentPeriodEndDate } = customer.subscription;
  return status === 'CANCELLED' && isAfter(parseISO(currentPeriodEndDate), new Date());
}
